import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { ToastController, LoadingController, IonIcon } from '@ionic/angular/standalone';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { GlobalDataService } from '../../providers/global-data.service';
import { UserCollectionsServices } from '../../providers/user-collection-services';
import { Storage } from '@ionic/storage-angular';
import { SharedService } from '../../pages/user-collection/shared/shared.service';
import { Browser } from '@capacitor/browser';
import { AgentsService } from '../../providers/crm-agent-provider';
import { addIcons } from 'ionicons';
import { closeOutline, cardOutline, chevronBackOutline } from 'ionicons/icons';
import { CommonModule, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SvgPreloadService } from '../../providers/svg-preload.service';
import lottie from 'lottie-web';
import { BtnComponent } from '../btn/btn.component';
import { Subscription } from 'rxjs';
import { PopupService } from '../../providers/popup.service';
import { finMethodFromCountry } from '../../../utils/fin-method';

@Component({
  selector: 'app-v2-get-binders',
  standalone: true,
  templateUrl: './v2-get-binders.component.html',
  styleUrls: ['./v2-get-binders.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IonIcon, NgIf, FormsModule, TranslatePipe, CommonModule, BtnComponent],
})
export class V2GetBindersComponent implements OnChanges, OnDestroy {
  @ViewChild('overlayRoot', { read: ElementRef }) overlayRootEl?: ElementRef<HTMLDivElement>;
  @ViewChildren('lottieLoader') lottieContainers: QueryList<ElementRef>;

  /** Manage-style header + content reveal (same pattern as v2-open-binders / v2-open-spinners). */
  headerReveal = false;
  contentReveal = false;
  private headerRevealRaf1 = 0;
  private headerRevealRaf2 = 0;
  
  gotMethods: number=0;
  finMethodsValid: any = {};
  isMBWayValid: boolean=false;
  isVisaValid: boolean=false;
  
  minBinders: number = 20;
  maxBinders: number = 400;
  formValid: boolean = false;
  num_binders: number;
  pcents: number;
  cardsPerBinder: number;
  msisdn: string;
  total_value: number;
  openInv: boolean = false;
  invoice_required: boolean = false;
  storeNIF: boolean = false;
  storeMsisdn: boolean = false;
  finMethod: string = 'UNDEFINED';
  // AgentId: string;
  // userCollectionId: string;
  // collectionId: string;
  nif_for_invoice: string;
  numBindersToOpen = -1;
  getBindersButtonOne: number=-1;
  getBindersButtonTwo: number=-1;
  getBindersButtonThree: number=-1;
  getBindersButtonFour: number=-1;
  collectionIconPath = '';
  numSpinners = -1;
  body = document.body;

  @Input() isOpen = false;
  @Input() agentId = '';
  @Input() collectionId = '';
  @Input() userCollectionId = '';
  /** Gift-only collection: show info message instead of purchase UI. */
  @Input() giftInfoOnly = false;
  @Output() closed = new EventEmitter<any>();

  theAgentId: string;
  theCollectionId: string;
  theUserCollectionId: string;
  nif_for_invoice2: string;
  msisdn2: string;

  isLoading: boolean = true;

  domOpen = false;
  isClosing = false;
  private closeAnimationFinishTimer: ReturnType<typeof setTimeout> | null = null;
  private static readonly OVERLAY_CLOSE_ANIM_MS = 400;

  /**
   * Set after `getBinders()` succeeds (payment flow started). Cleared on open.
   * On overlay close, triggers `refreshActiveCollectionFromStatus` so counts can reflect
   * payment that may complete while the user is away (e.g. VISA browser).
   */
  private refreshActiveCollectionAfterGetBindersPending = false;

  /** Load generation + active collection subscription (aligned with v2-open-binders). */
  private loadSeq = 0;
  private activeCollectionSub?: Subscription;

  constructor(
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private popup: PopupService,
    private ga: GoogleAnalytics,
    private gds: GlobalDataService,
    public localStorage: Storage,
    private userColectionsService: UserCollectionsServices,
    public translate: TranslateService,
    private sharedService: SharedService,
    private agentService: AgentsService,
    private svgPreloadService: SvgPreloadService,
  ) {
    addIcons({ closeOutline, cardOutline, chevronBackOutline });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.clearCloseAnimationFinishTimer();
        const wasClosing = this.isClosing;
        this.isClosing = false;
        this.domOpen = true;
        this.contentReveal = false;
        this.refreshActiveCollectionAfterGetBindersPending = false;
        this.theAgentId = this.agentId;
        this.theCollectionId = this.collectionId;
        this.theUserCollectionId = this.userCollectionId;
        this.setBodyScrollLock(true);
        if (wasClosing) {
          setTimeout(() => this.resetOverlayEnterAnimationStyles(), 0);
        }
        this.scheduleHeaderRevealAnimation();
        if (this.giftInfoOnly) {
          this.collectionIconPath = '';
          this.hydrateCollectionIconForGiftMode();
          this.isLoading = false;
          this.scheduleContentReveal();
        } else {
          void this.loadGetBindersFlow();
        }
      } else {
        void this.maybeRefreshActiveCollectionAfterGetBindersClose();
        this.cancelHeaderRevealAnimation();
        this.headerReveal = false;
        this.contentReveal = false;
        this.clearActiveCollectionSub();
        if (this.domOpen) {
          this.isClosing = true;
          this.scheduleCloseAnimationFinish();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.cancelHeaderRevealAnimation();
    this.clearCloseAnimationFinishTimer();
    this.clearActiveCollectionSub();
    this.setBodyScrollLock(false);
  }

  private async loadGetBindersFlow(): Promise<void> {
    if (!this.theAgentId || !this.theCollectionId || !this.theUserCollectionId) {
      return;
    }
    const seq = ++this.loadSeq;
    this.clearActiveCollectionSub();
    this.isLoading = true;
    this.loaderIconLoaderDelayed();

    console.log('entering loadGetBindersFlow');
    console.log('bob ' + this.theCollectionId);
    console.log(this.theAgentId);

    // this.agentService
    //   .getCrmAgentById(this.theAgentId)
    //   .subscribe((data: any) => {
    //     console.log(data.resource[0].country_cca2);
    //     if (data.resource[0].country_cca2 !== 'PT') {
    //       console.log('User is not from Portugal');
    //       this.finMethod = 'VISA';
    //     } else if (data.resource[0].country_cca2 === 'PT') {
    //       console.log('User is from Portugal');
    //       this.finMethod = 'MBWAY';
    //     }
    //   });

    const agentRow = await this.gds.resolveAgentRow();
    if (seq !== this.loadSeq || !this.isOpen) return;
    if (agentRow) {
      this.finMethod = finMethodFromCountry(agentRow.country_cca2);
    }

    if (seq !== this.loadSeq || !this.isOpen) return;

    this.formValid = false;
    // this.userColectionsService.getCollectionFin(this.theCollectionId).subscribe(
    //   (res: any) => {
    //     console.log('executed getCollectionFin. response is:');
    //     console.log(res);
    //     this.pcents = res.resource[0].binder_pcents;
    //     this.cardsPerBinder = res.resource[0].binderNumCards;
    //   },
    //   (err) => {
    //     console.log(err);
    //     this.dismissPage();
    //   }
    // );

    const finCached = this.gds.getCollectionFin().getValue();
    if (
      finCached &&
      String(finCached.collectionId) === String(this.theCollectionId)
    ) {
      this.pcents = finCached.binder_pcents;
      this.cardsPerBinder = finCached.binderNumCards;
      console.log('getCollectionFin from GDS, pcents=' + this.pcents);
    } else {
      try {
        const res: any = await this.userColectionsService.getCollectionFin(
          this.theCollectionId
        );
        console.log('executed getCollectionFin. response is:');
        console.log(res);
        const row = res.resource[0];
        this.pcents = row.binder_pcents;
        this.cardsPerBinder = row.binderNumCards;
        this.gds.publishCollectionFin({
          collectionId: String(this.theCollectionId),
          binder_pcents: row.binder_pcents,
          binderNumCards: row.binderNumCards,
        });
        console.log('this.pcents=' + this.pcents);
        console.log('this.cardsPerBinder=' + this.cardsPerBinder);
      } catch (err) {
        console.log(err);
        this.dismissPage();
        return;
      }
    }

    if (seq !== this.loadSeq || !this.isOpen) return;
    
    try {
      const res: any = await this.userColectionsService.getCollectionFinMethods(this.theCollectionId, null);
      console.log('executed getCollectionFinMethods. response is:');
      console.log(res);
      this.gotMethods=1;
      console.log(res.resource.p_return_message);
      this.finMethodsValid= res.resource.p_return_message;
      for( let i = 0; i< this.finMethodsValid.available_methods.length; i++) {
        console.log(this.finMethodsValid.available_methods[i])
        if ( this.finMethodsValid.available_methods[i].name == 'MBWAY') {
          console.log("setting MBWay");
          this.isMBWayValid = true;
        }
        if ( this.finMethodsValid.available_methods[i].name == 'VISA') {
          console.log("setting Visa");
          this.isVisaValid = true;
        }
      }
      this.finMethod = (this.isMBWayValid?'MBWAY': (this.isVisaValid?'VISA':'UNDEFINED') );
      this.calculateLimits();
      this.getBinderRecommendations();
    } catch (err) {
      this.gotMethods=0;
      console.log(err);
      this.dismissPage();
      return;
    }

    if (seq !== this.loadSeq || !this.isOpen) return;
    
    // this.userColectionsService.getAgentFinData(this.theAgentId).subscribe(
    //   (res: any) => {
    //     console.log('executed getAgentFinData. response is:');
    //     console.log(res);
    //     this.msisdn = res.resource[0].default_msisdn;
    //     this.msisdn2 = res.resource[0].default_msisdn;
    //     this.nif_for_invoice = res.resource[0].default_nif;
    //     this.nif_for_invoice2 = res.resource[0].default_nif;
    //     console.log('Set nif to ' + this.nif_for_invoice2);
    //     console.log('Set msisdn to ' + this.msisdn2);
    //   },
    //   (err) => {
    //     console.log(err);
    //     this.dismissPage();
    //   }
    // );

    try {
      const res: any = await this.userColectionsService.getAgentFinData(this.theAgentId);
      console.log('executed getAgentFinData. response is:');
      console.log(res);
      const finRow = res.resource?.[0];
      this.msisdn = String(finRow?.default_msisdn ?? '');
      this.msisdn2 = String(finRow?.default_msisdn ?? '');
      this.nif_for_invoice = String(finRow?.default_nif ?? '');
      this.nif_for_invoice2 = String(finRow?.default_nif ?? '');
      console.log('Set nif to ' + this.nif_for_invoice2);
      console.log('Set msisdn to ' + this.msisdn2);
    } catch (err) {
      console.log(err);
      this.dismissPage();
      return;
    }

    if (seq !== this.loadSeq || !this.isOpen) return;

    /** Collection row from GDS (same as v2-open-binders); fallback API only if missing. */
    this.hydrateCollectionRowAfterFinLoad(seq);
  }

  /** Same row shape as `getUserCollection` / `data.collection` on active collection. */
  private applyUserCollectionRow(row: any): void {
    this.numBindersToOpen = row.num_binders_to_open;
    this.collectionIconPath = row.collection_icon_path ?? '';
    this.numSpinners = row.num_spinners;
  }

  private matchesOverlayCollection(row: any): boolean {
    if (!row?.user_collection_id) return false;
    if (String(row.user_collection_id) !== String(this.theUserCollectionId)) return false;
    if (this.theCollectionId && row.collection_id != null) {
      return String(row.collection_id) === String(this.theCollectionId);
    }
    return true;
  }

  private clearActiveCollectionSub(): void {
    this.activeCollectionSub?.unsubscribe();
    this.activeCollectionSub = undefined;
  }

  /** Load collection icon for gift-only mode (no full fin flow). */
  private hydrateCollectionIconForGiftMode(): void {
    this.clearActiveCollectionSub();
    const snap = this.gds.getActiveCollection().getValue();
    if (snap?.collection && this.matchesOverlayCollection(snap.collection)) {
      this.collectionIconPath = snap.collection.collection_icon_path ?? '';
      return;
    }

    this.activeCollectionSub = this.gds.getActiveCollection().subscribe((data) => {
      if (!this.isOpen || !this.giftInfoOnly) return;
      if (!data?.collection) return;
      const row = data.collection;
      if (!this.matchesOverlayCollection(row)) return;
      this.collectionIconPath = row.collection_icon_path ?? '';
      this.clearActiveCollectionSub();
    });

    setTimeout(() => {
      if (!this.isOpen || !this.giftInfoOnly) return;
      if (this.collectionIconPath) return;
      void this.loadUserCollectionIconFallbackForGift();
    }, 400);
  }

  private async loadUserCollectionIconFallbackForGift(): Promise<void> {
    if (!this.isOpen || !this.giftInfoOnly) return;
    this.clearActiveCollectionSub();
    try {
      const res: any = await this.userColectionsService.getUserCollection(
        this.theUserCollectionId,
        this.theAgentId
      );
      const row = res.resource[0];
      this.collectionIconPath = row.collection_icon_path ?? '';
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Prefer `GlobalDataService.getActiveCollection()` (already on user-collection-items).
   * Subscribe for the next matching emission; if still missing after 400ms, one API fallback.
   */
  private hydrateCollectionRowAfterFinLoad(seq: number): void {
    const snap = this.gds.getActiveCollection().getValue();
    if (snap?.collection && this.matchesOverlayCollection(snap.collection)) {
      this.applyUserCollectionRow(snap.collection);
      this.closeLoader();
      this.scheduleContentReveal();
      return;
    }

    const state = { settled: false };
    this.clearActiveCollectionSub();
    this.activeCollectionSub = this.gds.getActiveCollection().subscribe((data) => {
      if (seq !== this.loadSeq || !this.isOpen || state.settled) return;
      if (!data?.collection) return;
      const row = data.collection;
      if (!this.matchesOverlayCollection(row)) return;
      this.applyUserCollectionRow(row);
      state.settled = true;
      this.clearActiveCollectionSub();
      this.closeLoader();
      this.scheduleContentReveal();
    });

    setTimeout(() => {
      if (seq !== this.loadSeq || !this.isOpen || state.settled) return;
      void this.loadUserCollectionFallback(seq);
    }, 400);
  }

  /** If active collection is not published yet (or IDs mismatch), fall back once — v2-open-binders parity. */
  private async loadUserCollectionFallback(seq: number): Promise<void> {
    if (seq !== this.loadSeq || !this.isOpen) return;
    this.clearActiveCollectionSub();
    try {
      const res: any = await this.userColectionsService.getUserCollection(
        this.theUserCollectionId,
        this.theAgentId
      );
      const row = res.resource[0];
      this.applyUserCollectionRow(row);
      this.closeLoader();
      this.scheduleContentReveal();
    } catch (err) {
      console.log(err);
      if (seq === this.loadSeq && this.isOpen) {
        this.dismissPage();
      }
    }
  }

  closeLoader() {
    const root = this.overlayRootEl?.nativeElement;
    root?.querySelectorAll('.loader-parent').forEach((el) => {
      (el as HTMLElement).style.opacity = '0';
    });
    setTimeout(() => {
      this.isLoading = false;
    }, 400);
  }

  getBinderRecommendations() {
    if (this.minBinders >= this.maxBinders) {
      this.getBindersButtonOne=-1;
      this.getBindersButtonTwo=-1;
      this.getBindersButtonThree=-1;
      this.getBindersButtonFour=-1;
    }

    // Always include the min and max
    this.getBindersButtonOne = this.minBinders;
    this.getBindersButtonFour = this.maxBinders;

    // Divide the range into 3 equal gaps between the four buttons
    const step = Math.max(1,(this.maxBinders - this.minBinders) / 3);

    // Calculate mid values, rounded to "round numbers"
    const roundToNearest = (value: number, base: number = 5) =>
      Math.round(value / base) * base;

    this.getBindersButtonTwo = roundToNearest(this.minBinders + step);
    this.getBindersButtonThree = roundToNearest(this.minBinders + 2 * step);
  }

  calculateLimits(){
    for( let i = 0; i< this.finMethodsValid.available_methods.length; i++) {
      console.log(this.finMethodsValid.available_methods[i])
      if ( this.finMethodsValid.available_methods[i].name == this.finMethod) {
        console.log("setting limits for " + this.finMethod);
        this.minBinders = this.finMethodsValid.available_methods[i].min_binders;
        this.maxBinders = this.finMethodsValid.available_methods[i].max_binders;
      }
    }
    
  }

  setFinMethod(method: string) {
    console.log('Setting fin method');
    this.finMethod = method;
    console.log('Set to: ' + this.finMethod);
    if (this.finMethod === 'VISA') {
      this.storeMsisdn = false;
    }
    this.calculateLimits();
    this.getBinderRecommendations();
    this.evalValuesNumberBinders();
    
  }
  dismissPage() {
    this.closeLoader();
    this.emitDismiss({});
  }

  private async maybeRefreshActiveCollectionAfterGetBindersClose(): Promise<void> {
    if (!this.refreshActiveCollectionAfterGetBindersPending) {
      return;
    }
    this.refreshActiveCollectionAfterGetBindersPending = false;
    if (!this.theUserCollectionId || !this.theAgentId) {
      return;
    }
    try {
      await this.userColectionsService.refreshActiveCollectionFromStatus(
        this.theUserCollectionId,
        this.theAgentId.toString()
      );
    } catch (refreshErr) {
      console.error(
        'Failed to refresh active collection after get-binders overlay close',
        refreshErr
      );
    }
  }

  private emitDismiss(data: any): void {
    this.closed.emit(data);
  }

  private clearCloseAnimationFinishTimer(): void {
    if (this.closeAnimationFinishTimer) {
      clearTimeout(this.closeAnimationFinishTimer);
      this.closeAnimationFinishTimer = null;
    }
  }

  private scheduleCloseAnimationFinish(): void {
    this.clearCloseAnimationFinishTimer();
    const ms = this.getOverlayCloseAnimDurationMs();
    this.closeAnimationFinishTimer = setTimeout(() => {
      this.closeAnimationFinishTimer = null;
      this.isClosing = false;
      this.domOpen = false;
      this.setBodyScrollLock(false);
    }, ms);
  }

  private getOverlayCloseAnimDurationMs(): number {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return V2GetBindersComponent.OVERLAY_CLOSE_ANIM_MS;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 0
      : V2GetBindersComponent.OVERLAY_CLOSE_ANIM_MS;
  }

  private scheduleHeaderRevealAnimation(): void {
    this.cancelHeaderRevealAnimation();
    this.headerReveal = false;
    this.headerRevealRaf1 = requestAnimationFrame(() => {
      this.headerRevealRaf1 = 0;
      this.headerRevealRaf2 = requestAnimationFrame(() => {
        this.headerRevealRaf2 = 0;
        this.headerReveal = true;
      });
    });
  }

  private cancelHeaderRevealAnimation(): void {
    if (this.headerRevealRaf1) {
      cancelAnimationFrame(this.headerRevealRaf1);
      this.headerRevealRaf1 = 0;
    }
    if (this.headerRevealRaf2) {
      cancelAnimationFrame(this.headerRevealRaf2);
      this.headerRevealRaf2 = 0;
    }
  }

  private resetOverlayEnterAnimationStyles(): void {
    const el = this.overlayRootEl?.nativeElement;
    if (!el) return;
    el.style.animation = 'none';
    el.style.opacity = '1';
    el.style.transform = 'scale(1)';
    void el.offsetWidth;
    el.style.removeProperty('animation');
    el.style.removeProperty('opacity');
    el.style.removeProperty('transform');
  }

  /** Staggered content entrance after load (matches v2-open-binders `finishLoadPageData`). */
  private scheduleContentReveal(): void {
    setTimeout(() => {
      if (!this.isOpen || !this.domOpen) return;
      this.contentReveal = true;
    }, 50);
  }

  private setBodyScrollLock(locked: boolean): void {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('v2-get-binders-open', locked);
  }

  setVal() {
    if (this.num_binders === undefined || this.pcents === undefined) {
      this.total_value = null;
    } else {
      this.total_value = (this.num_binders * this.pcents) / 100;
    }
    console.log('Total Value:' + this.total_value);
    console.log('pcents:' + this.pcents);
  }

  evalValuesMSISDN(): void {
    this.msisdn = this.msisdn2 != null ? String(this.msisdn2) : '';
    setTimeout(() => {
      this.evalValues2();
    }, 200);
  }

  evalValuesNumberBinders() {
    this.setVal();
    console.log(' entering evalValuesNumberBinders ');
    setTimeout(() => {
      this.evalValues2();
    }, 50);
  }

  evalValues2() {
    console.log(' entering eval Values 2');
    console.log(this.pcents);
    console.log(this.num_binders);
    console.log(this.minBinders);
    console.log(this.maxBinders);
    console.log(this.msisdn);
    const msisdn_num = parseInt(this.msisdn);
    if (
      this.num_binders !== undefined &&
      this.num_binders != null &&
      this.num_binders >= this.minBinders &&
      this.num_binders <= this.maxBinders &&
      ((this.finMethod === 'MBWAY' &&
        this.msisdn !== undefined &&
        this.msisdn != null &&
        msisdn_num >= 900000000 &&
        msisdn_num <= 999999999) ||
        this.finMethod === 'VISA')
    ) {
      console.log('returning true');
      if ( this.gotMethods == 0) {
        this.formValid = false;
      } else {
        if (this.num_binders >= this.minBinders || this.num_binders <= this.maxBinders) {
          this.formValid = true;
        } else {
          this.formValid = false;
        }

      }
    } else {
      console.log('returning false');
      this.formValid = false;
    }
  }

  setQty(number_of_binders: number) {
    if (number_of_binders < 0) return;
    this.num_binders = number_of_binders;
    this.evalValuesNumberBinders();
  }

  async get() {
    console.log('##############################################');
    console.log('Executing get');
    console.log('Parameters are:');
    console.log('Agent_Id:' + this.theAgentId);
    console.log('User Collection Id:' + this.theUserCollectionId);
    console.log('Collection Id:' + this.theCollectionId);
    console.log('Fin Method:' + this.finMethod);
    console.log('Número de Carteirinhas: ' + this.num_binders);
    console.log('Valor da Compra:' + this.total_value);
    console.log('MSISDN:' + this.msisdn);
    console.log('Require Invoice:' + this.invoice_required);
    console.log('NIF:' + this.nif_for_invoice);
    console.log('Store NIF:' + this.storeNIF);
    console.log('Store Msisdn:' + this.storeMsisdn);
    console.log('##############################################');

    const request = {
      requestType: 'GET_BINDERS',
      /*buyNumBinders*/ getNumBinders: this.num_binders,
      /*buyTotalValue*/ getTotalValue: this.total_value,
      /*buyMsisdn*/ getMsisdn: this.finMethod === 'MBWAY' ? this.msisdn : '',
      /*buyPaymentType*/ getFinType: this.finMethod,
      /*buyInvoiceRequired*/ getInvoiceRequired: this.invoice_required ? 1 : 0,
      /*buyNifForInvoice*/ getNifForInvoice: this.nif_for_invoice,
      /*buyStoreNIF*/ getStoreNIF: this.storeNIF ? 1 : 0,
      /*buyStoreMsisdn*/ getStoreMsisdn:
        this.finMethod === 'MBWAY' ? (this.storeMsisdn ? 1 : 0) : 0,
    };
    console.log(request);

    const loading = await this.loadingCtrl.create({
      showBackdrop: true,
      spinner: 'bubbles',
    });
    loading.present();


    const showErrorAlert = (message?: string) => {
      this.popup.open({
        title: this.translate.instant('ERROR_TITLE'),
        message: message || this.translate.instant('ERROR_IN_FIN'),
        confirmText: this.translate.instant('OK'),
      });
    };

    try {
      const res: any = await this.userColectionsService.getBinders(
        this.theAgentId,
        this.theUserCollectionId,
        this.theCollectionId,
        JSON.stringify(request)
      );

      await loading.dismiss();
      console.log(res);

      // Backend error check
      if (!res || res.status === 'ERROR' || res.success === false) {
        showErrorAlert();
        return;
      }

      this.showPurchaseSuccessPopup(res.finUrl);

    } catch (err) {
      console.error(err);
      await loading.dismiss();

      showErrorAlert();
    }
  }

  /**
   * Closes the overlay after a successful purchase.
   * VISA: opens the payment URL immediately. MBWAY: shows a confirm-popup.
   */
  private showPurchaseSuccessPopup(finUrl?: string): void {
    this.refreshActiveCollectionAfterGetBindersPending = true;
    this.dismissPage();

    if (this.finMethod === 'VISA') {
      if (finUrl) {
        this.openWithSystemBrowser(finUrl);
      }
      return;
    }

    if (this.finMethod === 'MBWAY') {
      this.popup.open({
        title: this.translate.instant('CHECK_MBWAY'),
        message: this.translate.instant('CHECK_MBWAY_MSG'),
        confirmText: this.translate.instant('OK'),
      });
    }
  }

  public openWithSystemBrowser(url: string) {
    Browser.open({ url: url });
  }

  openInvPressed() {
    console.log('openInvPressed');
  }

  NIFChanged(): void {
    this.nif_for_invoice =
      this.nif_for_invoice2 != null ? String(this.nif_for_invoice2) : '';
  }

  invRequiredPressed(): void {
    this.evalValues2();
  }

  invRequired(inputEvent: any) {
    // TODO:
  }

  storeMsisdnPressed() {
    console.log('storeMsisdnPressed()');
  }
  storeNIFPressed() {
    console.log('storeNIFPressed()');
  }

  async presentToast(msg: string, tcolor: string) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 3000,
      color: tcolor,
    });
    toast.present();
  }


  loaderIconLoaderDelayed() {
    const svgContent = this.svgPreloadService.getSvgContent('loaderSvg');
    if (svgContent) {
      setTimeout(() => {
        this.lottieContainers.forEach((container, index) => {
          if (!container.nativeElement._lottieLoaded) {
            lottie.loadAnimation({
              container: container.nativeElement,
              animationData: JSON.parse(svgContent),
              renderer: 'svg',
              loop: true,
              autoplay: true,
            });
            container.nativeElement._lottieLoaded = true; // Mark this container as initialized
          }
        });
      }, 50);
    }
  }
}
